<template>
  <div class="msl-multi-select">
    <c-multiselect-searchablelist
      :list-items="availableOptions"
      :no-options-text="noOptionsText"
      :no-items-found-text="noOptionsFoundText"
      :selected-list-items="selectedItems"
      :display-property="reduceDisplayProperty"
      :value-property="reduceValueProperty"
      :placeholder-text="searchOptionsPlaceholder"
      :search-input-class="searchInputClass"
      class="msl-multi-select__list"
      @onClickOption="onOptionSelect"
    />

    <div class="msl-multi-select__actions">
      <a
        class="msl-multi-select__action msl-multi-select__action-select-all"
        :class="{'invisible': !showSelectAllButtons}"
        @click="onSelectAllOptions"
      >
        <font-awesome-icon icon="angle-double-right" />
      </a>

      <font-awesome-icon icon="exchange-alt" class="multi-select__action-icon" />

      <a
        class="msl-multi-select__action msl-multi-select__action-unselect-all"
        :class="{'invisible': !showSelectAllButtons}"
        @click="onUnselectAllOptions"
      >
        <font-awesome-icon icon="angle-double-left" />
      </a>
    </div>

    <c-multiselect-searchablelist
      :list-items="selectedItems"
      :no-options-text="selectedNoOptionsText"
      :no-items-found-text="noSelectedOptionsFoundText"
      :display-property="reduceDisplayProperty"
      :value-property="reduceValueProperty"
      :placeholder-text="selectedOptionsPlaceholder"
      :search-input-class="searchInputClass"
      class="msl-multi-select__selected msl-multi-select__list"
      @onClickOption="onOptionRemove"
    />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExchangeAlt, faAngleDoubleRight, faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';

library.add(faExchangeAlt, faAngleDoubleLeft, faAngleDoubleRight);

function getValueFromOption(valueProperty, option) {
  return valueProperty ? option[valueProperty] : option;
}

function getValuesFromOptions(valueProperty, options) {
  const values = [];

  options.forEach((option) => {
    values.push(getValueFromOption(valueProperty, option));
  });

  return values;
}

export default {
  components: {
    FontAwesomeIcon,
  },
  model: {
    prop: 'value',
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedItems: {
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    searchOptionsPlaceholder: {
      type: String,
      default() {
        return 'Search';
      },
    },
    selectedOptionsPlaceholder: {
      type: String,
      default() {
        return 'Search';
      },
    },
    reduceDisplayProperty: {
      type: Function,
      default: (value) => value,
    },
    reduceValueProperty: {
      type: Function,
      default: (value) => value,
    },
    noOptionsText: {
      type: String,
      default: '',
    },
    selectedNoOptionsText: {
      type: String,
      default: 'Select',
    },
    noOptionsFoundText: {
      type: String,
      default: 'No options found',
    },
    noSelectedOptionsFoundText: {
      type: String,
      default: 'No options found',
    },
    showSelectAllButtons: {
      type: Boolean,
      default: true,
    },
    searchInputClass: {
      type: String,
      default: '',
    },
  },
  /*data() {
    return {
      selectedItems: this.selected
    };
  },*/
  computed: {
    availableOptions() {
      
      return this.options.filter((option) => {
        
        if(this.selectedItems.map(function(e) { return e.id; }).indexOf(option.id) == -1) {
          return option;
        }
      });
    },
  },
  methods: {
    onOptionSelect(option) {
      this.selectedItems.push(option);
      const items = [...this.value, getValueFromOption(this.valueProperty, option)];
      this.$emit('input', items);
      this.$emit('change', items);
    },
    onOptionRemove(option) {
      const items = [...this.value];
      const { selectedItems } = this;

      let valueIndex = items.findIndex((item) => {
        if (this.valueProperty) {
          return item && option && (item === option[this.valueProperty]);
        }

        return item === option;
      });

      items.splice(valueIndex, 1);

      valueIndex = selectedItems.findIndex((item) => {
        if (this.valueProperty) {
          return item && option && (item[this.valueProperty] === option[this.valueProperty]);
        }

        return item === option;
      });

      selectedItems.splice(valueIndex, 1);

      this.selectedItems = [...selectedItems];

      this.$emit('input', items);
      this.$emit('change', items);
    },
    onSelectAllOptions() {
      this.selectedItems = [...this.options];

      const selectedValues = getValuesFromOptions(this.valueProperty, this.options);
      this.$emit('input', selectedValues);
      this.$emit('change', selectedValues);
    },
    onUnselectAllOptions() {
      this.selectedItems = [];

      this.$emit('input', []);
      this.$emit('change', []);
    },
  },
};

</script>

<style lang="scss">
// Searchable listbox
$msl-multi-select-items-box-border-color: #5b5d66 !default;
$msl-multi-select-item-border-bottom-color: #252b45 !default;
$msl-multi-select-item-hover-bg: #3858e7 !default;
$msl-multi-select-item-hover-font-color: #fff !default;
$msl-multi-select-no-item-font-color: #c0c2c6 !default;

// The select all icons
$msl-multi-select-action-hover-font-color: #c0c2c6 !default;
$msl-multi-select-action-icon-font-color: #919191 !default;

.invisible {
  visibility: hidden;
}

.msl-search-list-input {
  margin-bottom: 10px;
}

.msl-searchable-list {
  display: flex;
  flex-direction: column;
}

.msl-searchable-list__items {
  border: 1px solid $msl-multi-select-items-box-border-color;
  flex-basis: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.msl-searchable-list__no-item {
  font-size: 0.8em;
  padding: 5px 10px;
  color: $msl-multi-select-no-item-font-color;
}

.msl-searchable-list__item {
  font-size: 0.9em;
  padding: 5px 10px;
  cursor: pointer;
  border-bottom: 1px solid $msl-multi-select-item-border-bottom-color;
  &:hover {
    background: $msl-multi-select-item-hover-bg;
    color: $msl-multi-select-item-hover-font-color;
  }
}

.msl-multi-select {
  display: inline-flex;
  height: 300px;
}

.msl-multi-select__actions {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
}

.msl-multi-select__action {
  cursor: pointer;

  &:hover {
    color: $msl-multi-select-action-hover-font-color;
  }
}

.msl-multi-select__action-select-all {
  margin-bottom: 20px;
}

.msl-multi-select__action-unselect-all {
  margin-top: 20px;
}

.msl-multi-select__action-icon {
  margin-top: 17px;
  color: $msl-multi-select-action-icon-font-color;
}

.msl-multi-select__list {
  width: 100%;
}
</style>
